<div class="view-sidebar-container" fxLayout="column" *ngIf="customViewForm && opened">
  <form [formGroup]="customViewForm" fxLayout="column">
    <div fxFlex="100%" fxLayout="row" fxLayoutAlign="space-between center">
      <h3 fxLayout="row" fxLayoutAlign="start center">{{ editMode ? 'Edit ' + title : 'New ' + title }}</h3>
      <div class="button-container">
        <button
          mat-button
          color="primary"
          type="submit"
          class="text-uppercase"
          [disabled]="isSaving"
          (click)="onSave()"
        >
          <mat-icon>check</mat-icon> Save
        </button>
        <button type="button" class="text-uppercase" type="reset" mat-button (click)="onClose()" [disabled]="isSaving">
          <mat-icon>close</mat-icon> Cancel
        </button>
      </div>
    </div>
    <div class="view-contect" fxLayout="column">
      <div fxLayout="column" class="info-panel">
        <mat-form-field floatLabel="always" appearance="outline" hideRequiredMarker>
          <mat-label>Name</mat-label>
          <input matInput type="text" formControlName="viewName" placeholder="Required" maxlength="50" />
          <mat-error *ngIf="customViewForm.get('viewName').hasError('required')"> Name is required </mat-error>
        </mat-form-field>
        <p>
          Only you will be able to see this view. If you would like to share this view with everyone else, click “Shared
          view” below."
        </p>
        <mat-checkbox formControlName="isPublic" color="primary">Shared view</mat-checkbox>
      </div>
      <div class="filter-panel-content">
        <p *ngIf="selectedFilters.length == 0">No filters applied. Results showing all teams.</p>
        <div
          *ngFor="let selectedFilter of selectedFilters; let i = index"
          class="filters"
          [class.sub-filters-added]="selectedFilter.isSubFilterAdded"
        >
          <odata-filter-item
            [selectedFilter]="selectedFilter"
            [filters]="filters"
            (delete)="deleteFilter(i)"
            (addSubFilter)="addSubFilter(selectedFilter)"
          >
          </odata-filter-item>
          <div *ngIf="selectedFilter.isSubFilterAdded" class="sub-filters">
            <p class="sub-filters-title">Conditions</p>
            <div *ngFor="let selectedSubFilter of selectedFilter.selectedSubFilters; let i = index" class="filters">
              <odata-filter-item
                [selectedFilter]="selectedSubFilter"
                [filters]="selectedFilter.filter.subFilter.filters"
                (delete)="deleteSubFilter(selectedFilter, i)"
              >
              </odata-filter-item>
            </div>
            <button class="add-filter-button" mat-button color="primary" (click)="addSubFilter(selectedFilter)">
              + ADD ANOTHER CONDITION
            </button>
          </div>
        </div>
        <button class="add-filter-button" mat-button color="primary" (click)="addFilter()">+ ADD FILTER</button>
      </div>
      <div class="filter-panel-action-buttons">
        <p *ngIf="!isValid && isApplied" class="error-message">
          Please make sure to select all values, or remove the filter before applying.
        </p>
      </div>
    </div>
  </form>
  <div fxFlex *ngIf="viewContext == viewContextEnum.People">
    <h4>Display Layout</h4>
    <mat-button-toggle-group [(ngModel)]="customViewDisplayLayout" class="layout-toggle-group">
      <mat-button-toggle [value]="customViewDisplayLayoutEnum.List" aria-label="List">
        <mat-icon>view_list</mat-icon>
      </mat-button-toggle>
      <mat-button-toggle [value]="customViewDisplayLayoutEnum.Table" aria-label="Table">
        <mat-icon>grid_on</mat-icon>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <app-plan-upgrade-box
    *ngIf="!canManageColumns && customViewDisplayLayout == customViewDisplayLayoutEnum.Table"
    title="Upgrade to customize the displayed columns"
    body="You’ll be able to select which columns are on display from a wide range of data. Even better, you’ll be able to save the columns with your views, so you can set it and forget it."
  >
  </app-plan-upgrade-box>
  <lineup-manage-columns
    *ngIf="showManageColumns"
    [columns]="columns"
    [viewContext]="selectedView.viewContext"
  ></lineup-manage-columns>
</div>
